export type Environment = 'dev' | 'dev-shared' | 'prod';

// The CLI release workflow runs `npm version ...` in apps/cli before the
// prod esbuild step. The build script then inlines that stamped package
// version as `LORE_CLI_VERSION`; local pnpm/tsx runs fall back to the
// package-version env var that pnpm sets for scripts.
const CLI_VERSION =
  process.env.LORE_CLI_VERSION ?? process.env.npm_package_version ?? 'dev';
const CLI_USER_AGENT = `@loredotlink/cli/${CLI_VERSION}`;

// Read lazily because the desktop configures this token before invoking shared
// CLI modules. Production builds still replace the expression with 'prod'.
// Initialization-time consumers (currently observability/instrument.ts) still
// require the environment to be configured before they are imported.
export function getCurrentEnvironment(): Environment {
  return (process.env.LORE_BUILD_ENV as Environment | undefined) ?? 'dev';
}

export function getCliVersion(): string {
  return CLI_VERSION;
}

export function getCliUserAgent(): string {
  return CLI_USER_AGENT;
}
